// Pure transformation behind useReformattedSchedules. Kept dependency-free (no
// React / context / models) so it can be unit-tested in isolation.
//
// Given the raw schedules plus the selected sitting length (minValue, in minutes)
// and the school's appointment interval (apptTimeframe, in minutes), build a
// { shootingDay -> [timeslot, ...] } map of bookable start times.
const reformatSchedules = (schedules, minValue, currentSchoolId, apptTimeframe) => {
  if (!apptTimeframe) return {}
  if (schedules.some((schedule) => !schedule.availableTimeslots)) return {}

  const shootingDays = [...new Set(schedules.map((schedule) => {
    if (schedule.schoolId === 1075) return `${schedule.shootingDay} @ Shoob`

    return schedule.shootingDay;
  }))]

  const blocksPerAppointment = Math.round(minValue / apptTimeframe) || 1

  const daysToTimes = shootingDays.map((shootingDay) => {
    const times = schedules
      .filter((schedule) => {
        if (shootingDay.includes('@ Shoob')) {
          return schedule.shootingDay === shootingDay.split('@')[0].trim() && schedule.schoolId === 1075
        }

        return schedule.shootingDay === shootingDay && schedule.schoolId === parseInt(currentSchoolId.toString(), 10)
      })
      .map((schedule) => schedule.availableTimeslots)
      .flat()
      // numAvailable is the block's free capacity in minutes (interval * free
      // photographers), NOT the whole sitting length. A sitting longer than one
      // block is handled by spanning `blocksPerAppointment` blocks below — so here
      // we only require the block to have room for one appointment start (one free
      // photographer-block). Comparing against minValue (the full sitting duration)
      // wrongly hid every slot for sittings longer than one interval (super/deluxe).
      .filter((timeslot) => timeslot.numAvailable >= apptTimeframe)
      .filter((_schedule, i) => i % blocksPerAppointment === 0 )

    return [shootingDay, times]
  })

  return Object.fromEntries(daysToTimes)
}

export default reformatSchedules
